/**
 * /* eslint-disable no-console
 *
 * @format
 */

import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import { Checkbox, Divider, Header, Icon } from 'semantic-ui-react';
import { getCurrentUserToken } from '../../lib/auth';
import { Endpoints as url } from '../../lib/endpoints';
import Axios from 'axios';

import './ImportDevices.css';

const ImportDevices = ({
  ApplicationId,
  onUploadFinished,
  disabled = false,
}) => {
  const [ignoreDuplicates, setIgnoreDuplicates] = useState(false);

  const onDrop = acceptedFiles => {
    // Do something with the files

    const formData = new FormData();
    formData.append('file', acceptedFiles[0]);

    Axios.post(url.DevicesImport(ApplicationId), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getCurrentUserToken(),
        'pt-ns-options-igonre-duplicates': ignoreDuplicates,
      },
    })
      .then(res => onUploadFinished(res))
      .catch(error => onUploadFinished(error));
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: 'text/csv',
    disabled: disabled,
  });
  return (
    <>
      <div
        {...getRootProps()}
        className={`drag-and-drop-area ${disabled ? 'disabled' : ''}`}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p className="text-center">Drop the file here ...</p>
        ) : (
          <p className="text-center">
            Drag 'n' drop some file here, or click to select file
          </p>
        )}
      </div>
      <Divider horizontal>
        <Header as="h4">
          <Icon name="options" />
          Options
        </Header>
      </Divider>
      <div>
        <Checkbox
          label="ignore duplicates"
          onChange={(e, data) => setIgnoreDuplicates(data.checked)}
          checked={ignoreDuplicates}
        />
      </div>
      <Divider hidden />
    </>
  );
};

ImportDevices.propTypes = {
  onUploadFinished: PropTypes.func,
  ApplicationId: PropTypes.number,
  disabled: PropTypes.bool,
};

export { ImportDevices };
